import { AppAction, AppActionType } from '../actions/app';
import { RefundPolicyCode } from '../api/models/refundPolicy';
import { CaptchaStatus } from '../models/app';
import { RespondentType } from '../models/questions';
import { AppNamespace } from '../state/app';

export const appReducer = (
    state: AppNamespace = {
        captchaV3: {
            status: CaptchaStatus.notLoaded,
            timeoutReached: false,
        },
        currencyFormat: '',
        currentTimezone: '',
        defaultUserCountry: '',
        event: {
            id: '',
            organizer_id: '',
            survey_type: RespondentType.buyer,
        },
        featureFlags: {},
        guestAge: '',
        guestId: '',
        isEventbriteTLD: true,
        locale: '',
        locales: [],
        refundPolicyCode: RefundPolicyCode.notDefined,
        refundPolicyValidityDays: null,
        request: {
            correlation_id: '',
            session_id: '',
            params: {},
            path: '',
        },
        requestExtraData: {
            ip: '',
            host: '',
            method: '',
        },
        splitIOProdKey: '',
        useAndroidProfile: false,
        useIosProfile: false,
        isPreloadedRouting: false,
    },
    action: AppAction,
) => {
    switch (action.type) {
        case AppActionType.initializeApp:
            return {
                ...state,
                ...action.payload,
            };

        case AppActionType.removeAppError: {
            return {
                ...state,
                errors: state.errors?.filter(
                    (error) => error.error !== action.payload,
                ),
            };
        }

        case AppActionType.retrieveOrderFailure: {
            return {
                ...state,
                errors: [...(state.errors || []), action.payload],
            };
        }

        case AppActionType.setCaptchaV3Token:
            return {
                ...state,
                captchaV3: { ...state.captchaV3, token: action.payload },
            };

        case AppActionType.setCaptchaV3Status:
            return {
                ...state,
                captchaV3: { ...state.captchaV3, status: action.payload },
            };

        case AppActionType.setIsCaptchaV3TimeoutReached:
            return {
                ...state,
                captchaV3: {
                    ...state.captchaV3,
                    timeoutReached: action.payload,
                },
            };

        case AppActionType.setIsAppRebrandActiveFromInitialState:
            return {
                ...state,
                isAppRebrandActiveFromInitialState: action.payload,
            };

        case AppActionType.setReloadAfterCheckout: {
            return {
                ...state,
                reloadAfterCheckout: action.payload,
            };
        }

        case AppActionType.updatePayinLockStatus:
            return {
                ...state,
                payins: {
                    ...(state.payins || {}),
                    amountLocked: action.payload,
                },
            };

        case AppActionType.wasExternalPaymentWindowBlocked:
            return {
                ...state,
                wasExternalPaymentWindowBlocked: action.payload,
            };

        case AppActionType.setIsPreloadedRouting:
            return {
                ...state,
                isPreloadedRouting: action.payload,
            };

        default:
            return state;
    }
};

const getWidgetParentUrl = (state: AppNamespace) => state.widgetParentUrl;

export const selectors = {
    getWidgetParentUrl,
};
